import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../SimpleBlockContent'
import { $textPrimary, $textTertiary } from '../../../styles/colors/semantics'

function HighlightedText({ text, textColor, highlight, highlightColor, highlightSx, highlightExactMatch, applySpace }) {
  return (
    <div className={styles.wrapper} style={{ '--highlighted-text-color': textColor ? textColor.value : $textPrimary.dark }}>
      <SimpleBlockContent
        blocks={text}
        highlight={highlight}
        highlightSx={highlightSx || `color: ${highlightColor ? highlightColor.value : $textTertiary.dark};`}
        highlightExactMatch={highlightExactMatch}
        noSpace
        applySpace={applySpace}
      />
    </div>
  )
}

export default HighlightedText
